/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2022-12-27 16:20:35
 * @LastEditors: linxi
 * @LastEditTime: 2023-11-10 13:16:31
 */
import { ColDef } from 'ag-grid-community'
import { Space, Switch, TableColumnType } from 'antd'
import moment from 'moment'
import React from 'react'
import { useSelector } from 'react-redux'
import { BillingCategoryName } from '../../models/billingCategory'

type ActionType = 'edit' | 'stateEdit'

export const AGColumns = (
  startIndex?: any,
  columnList?: any,
  isMerge?: any,
): ColDef[] => {

  return (
    columnList?.map((item: any) => {
      // 根据注释掉的列配置，补充 cellRendererFramework 或 valueFormatter
      switch (item.field) {
        case 'index':
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) {
                return (
                  <div style={{ fontWeight: 'bold', textAlign: 'center' }}>
                    合计
                  </div>
                );
              }
              return `${Number(startIndex || 0) + params.node.rowIndex + 1}`
            },
          };
        case 'tenantName': // 分店名称
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return isMerge == 1 ? '-' : value ? value : '-'
            }
          };
        case 'drugName': //药品信息
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? params.value : '-';
            },
          };
        case 'billingCategory': //开票项目
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              const { value } = params;
              if (params.node.rowPinned) return '';
              return value ? BillingCategoryName(value) : '-';
            },
          };
        case 'salesQuantity': //销售数量
        case 'salesSplitQuantity': //拆零销售数量
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              return Number(params.value) ;
            },
          }
        case 'accountUnit': //销售单位
        case 'splitUnit': //拆零单位
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value ? params.value : '-';
            },
          }
        case 'salesAmount': //销售金额
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
              }
            },
            cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = Number(t?.[field])
              return val >= 0 ? val.toFixed(2) : '-'
            },
          }
        case 'unitPrice': //成本单价
        case 'retailPrice':  //销售单价
        case 'retailSplitPrice': //拆零销售单价
        case 'unitSplitPrice': //拆零成本单价
          return {
            ...item,
            cellStyle: (params: any) => {
              const t = params.data;
              return {
                textAlign: 'center',
              }
            },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return Number(params.value) > -1 ? params.value : '-';
            },
          }
        case 'profit': //利润
        case 'costAmount': //成本金额
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
              cellRendererFramework: (params: any) => {
              const t = params.data;
              const field = item.field;
              const val = Number(t?.[field])
              return val >= 0 ? val.toFixed(2) : '-'
            },
          }
        case 'payStatus': //结算状态
          return {
            ...item,
            cellStyle: { textAlign: 'center' },
            cellRendererFramework: (params: any) => {
              if (params.node.rowPinned) return '';
              return params.value == 3 ? '已收费' : params.value == 5 ? '已退费' : '-';
            },
          }
        default:
          return {
            ...item,
            cellStyle: { textAlign: 'center', lineHeight: '40px', },
          };
      }
    })
  )
}
